export const convertUTCToLocal = (
  utcDateString: string | null | undefined,
): Date | null => {
  if (!utcDateString) return null;
  const utcDate = new Date(`${utcDateString}Z`);
  const localDate = new Date(utcDate);
  return localDate;
};

export const getLatestDate = (
  ...dates: Array<Date | undefined | null>
): Date | null => {
  const timestamps: Array<number> = dates
    .map((date) => date?.getTime())
    .filter((time) => time !== undefined && time !== null) as Array<number>;

  if (timestamps.length === 0) {
    return null;
  }

  const maxTimestamp = Math.max(...timestamps);
  return new Date(maxTimestamp);
};

/**
 * Converts a year/month selection to a date range representing the full month
 * @param year - The year (e.g., 2026)
 * @param month - The month (1-indexed: 1 = January, 12 = December)
 * @returns A tuple of [startDate, endDate] for the month
 */
export const monthToDateRange = (year: number, month: number): [Date, Date] => {
  // Start of month: first day at 00:00:00
  const startDate = new Date(year, month - 1, 1, 0, 0, 0, 0);

  // End of month: last day at 23:59:59.999
  const endDate = new Date(year, month, 0, 23, 59, 59, 999);

  return [startDate, endDate];
};

/**
 * Gets the current month as a MonthPicker value
 * @returns Object with current year and month (1-indexed)
 */
export const getCurrentMonth = (): { year: number; month: number } => {
  const now = new Date();
  return {
    year: now.getFullYear(),
    month: now.getMonth() + 1, // Convert to 1-indexed
  };
};
